// extracted by mini-css-extract-plugin
module.exports = {"tags":"tags_tags__Z19EZ","tag":"tags_tag__6xowa","highlight":"tags_highlight__a6iru"};